const $stageText = document.querySelector('.js-stage-text');
const $stageTextHeadline = document.querySelector('.js-stage-text-headline');

const setStageTextMaxWidth = () => {
  let headlineWidth = $stageTextHeadline.clientWidth;
  $stageText.style.maxWidth = `${headlineWidth}px`;

  setTimeout(() => {
    headlineWidth = $stageTextHeadline.clientWidth;
    $stageText.style.maxWidth = `${headlineWidth}px`;
  }, 100);

  setTimeout(() => {
    headlineWidth = $stageTextHeadline.clientWidth;
    $stageText.style.maxWidth = `${headlineWidth}px`;
  }, 150);

  setTimeout(() => {
    headlineWidth = $stageTextHeadline.clientWidth;
    $stageText.style.maxWidth = `${headlineWidth}px`;
  }, 200);
};

if ($stageTextHeadline) {
  document.addEventListener('DOMContentLoaded', setStageTextMaxWidth);
  window.addEventListener('resize', setStageTextMaxWidth);
}
